/**
 * Self-contained build-time feature flag for the SEGMENT-WEDGE HOVER MOTION
 * (ISP-9999) — a subtle radial "breath" on browse tiles.
 *
 * On a large browse tile (Gallery / Explore / folder list / segment library),
 * hovering the wheel eases every segment WEDGE gently outward along its own
 * centroid ray (a small radial separation / bloom), then settles back off-hover.
 * It is grounded in the design lab's "Breath" elevation (segment eases ~2.8%
 * outward; see designs/wheel-animation-lab/segment-anim/README.md), applied
 * wheel-wide because a tile hover targets the whole card, not one segment.
 *
 * Motion is GPU-only (a CSS `transform: translate` per wedge, driven by per-wedge
 * `--wtx`/`--wty` custom properties createPie sets from each arc's centroid). The
 * hover is pure CSS on the container class `wedge-hover-motion`, so ONLY the
 * hovered tile animates — no JS on hover, no wheel re-render (safe for the 10-30
 * wheels a gallery renders). Under `prefers-reduced-motion: reduce` the wedges
 * stay static.
 *
 * Mirrors tileGifHoverFlag.js / segmentArcFillsFlag.js: defaults OFF, flipped per
 * environment via REACT_APP_SEGMENT_HOVER_MOTION. Independent of the gif-hover and
 * arc-fill flags so it can roll out separately. When OFF, createPie never adds the
 * container class or the custom properties, so the tile renders byte-identical to
 * today. Gated per surface by the existing `gifHoverPreview` opt-in (the "this is a
 * large browse tile" signal), so View-Wheel / builder / mini-avatar wheels are
 * untouched either way.
 *
 * Flag-name collision audit: REACT_APP_SEGMENT_HOVER_MOTION is a new, unique name —
 * no existing REACT_APP_* var uses the SEGMENT_HOVER_MOTION token.
 *
 * At merge this can be folded into src/constants/featureFlags.js.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const SEGMENT_HOVER_MOTION_ENABLED = truthy(
  process.env.REACT_APP_SEGMENT_HOVER_MOTION
);
